import { isKnownEmojiStickerToken } from './EmojiStickerConfig';

export type MessageTextPart =
  | { kind: 'text'; text: string }
  | { kind: 'sticker'; token: string };

const STICKER_PATTERN = /\[([^\[\]]+)\]/g;

export function parseMessageTextParts(content: string): MessageTextPart[] {
  if (!content) {
    return [];
  }
  const parts: MessageTextPart[] = [];
  let lastIndex = 0;
  const pattern = new RegExp(STICKER_PATTERN.source, 'g');
  let match = pattern.exec(content);
  while (match) {
    const index = match.index;
    if (index > lastIndex) {
      parts.push({ kind: 'text', text: content.slice(lastIndex, index) });
    }
    const token = match[1];
    if (isKnownEmojiStickerToken(token)) {
      parts.push({ kind: 'sticker', token });
    } else {
      parts.push({ kind: 'text', text: match[0] });
    }
    lastIndex = index + match[0].length;
    match = pattern.exec(content);
  }
  if (lastIndex < content.length) {
    parts.push({ kind: 'text', text: content.slice(lastIndex) });
  }
  return parts;
}

export function insertTextAtCursor(
  text: string,
  insertion: string,
  selectionStart: number,
  selectionEnd: number,
): { next: string; cursor: number } {
  const next =
    text.slice(0, selectionStart) + insertion + text.slice(selectionEnd);
  return { next, cursor: selectionStart + insertion.length };
}
